// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__LqJje","footer":"ModalError_footer__2zUbJ"};